import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer.ts';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1.ts';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn.ts';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common.ts';
import {
	AddRelatedPersonByEmailDto,
	PersonByEmailLookupRes,
} from '@dealstack/shared/lib/generated';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';

export const lookupNaturalPersonByEmail = async ({
	email,
}: {
	email: string;
}): Promise<PersonByEmailLookupRes | null> => {
	const response = await makeRequest<ApiV1.Response<PersonByEmailLookupRes>>({
		endpoint: API_PATHS.PERSON_LOOKUP_BY_EMAIL_GET,
		method: HTTP_METHOD.GET,
		queryString: { email },
	});

	return response.payload ?? null;
};

export const addRelatedPersonByEmail = async (params: {
	personId: string;
	body: AddRelatedPersonByEmailDto;
}): Promise<void> => {
	return await makeRequest<ApiV1.Response<void>>({
		endpoint: formatUnicorn(API_PATHS.PERSON_PERSONID_RELATED_PEOPLE_BY_EMAIL_POST, {
			personId: params.personId,
		}),
		method: HTTP_METHOD.POST,
		body: JSON.stringify(params.body),
	}).then((response) => response.payload);
};
